const ProductThumbnailView = require('@component/product-thumbnail').default;
const ProductPoolMediaView = require('./ProductPoolMedia');
const template = require('../templates/partials/component-product-pool-media/grid.hbs');
const Grid = require('./Grid');

const View = ProductPoolMediaView.extend({
  template,
  bootstrap() {
    this.childView = ProductThumbnailView.extend({
      tagName: 'li',
    });
    this.productPool = new Grid({
      el: `#pp-${this.model.id}`,
      model: this.model,
      childView: this.childView,
    });
  },
});

module.exports = View;
